<template>
    <div
      v-if="notEmpty"
      @animationend="animationEnd"
      @click="onClick"
      :class="['asm-image', { 'asm-image--loaded': loaded, [animation]: animated, 'animated slow': animated, 'asm-image--shown': shown }]"
      itemscope itemtype="http://schema.org/ImageObject"
    >
      <meta v-if="alt" itemprop="name" :content="alt">
      <link v-if="src" itemprop="contentUrl" :href="src">

      <!--        @load.native="animationStart"-->
      <b-img-lazy
        @update:show="animationStart"
        @load="onLoad"
        v-bind="itemProps"
        :src="src"
        :alt="altText"
      />
    </div>
</template>

<script>
  import isEmpty from 'lodash/isEmpty'
  import R from 'ramda'

  import lightboxEmitter from "../mixins/lightboxEmitter.js";

  export default {
    name: 'asm-image',
    mixins: [
      lightboxEmitter
    ],
    inheritAttrs: false,
    props: {
      alt: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        default: ''
      },
      src: {
        type: String
      },
      width: {
        type: String
      },
      height: {
        type: String
      },
      'fluid-grow': {
        type: String
      },
      blankColor: {
        type: String,
        default: 'transparent'
      },
      animation: {
        type: String,
        default: 'fadeIn'
      },
      /**
       * Посылать ли при клике событие для Лайтбокса
       */
      lightbox: {
        type: Boolean,
        default: false
      },
    },
    data: () => ({
      shown: false,
      loaded: false,
      animated: false
    }),
    methods: {
      onClick(ev) {
        this.$emit('click', ev);
        if(this.lightbox) {
          ev.preventDefault();
          this.openLightbox([
            this.$props
          ], 0);
        }
      },
      onLoad() {
        this.$emit('load');
      },
      animationStart() {
        this.animated = true;
        this.shown = true;
      },
      animationEnd() {
        this.animated = false;
        this.shown = true;
      },
      // animateShow() {
      //   this.shown = true;
      // }
    },
    computed: {
      notEmpty() {
        return !isEmpty(this.src);
      },
      altText() {
        return this.alt || this.name;
      },
      itemProps() {
        return R.merge({
          center: true,
          fluid: true,
          blank: true,
          blankColor: this.blankColor,
          width: this.width,
          height: this.height
        }, this.$props)
      }
    }
  }
</script>

<style lang="scss">
  .asm-image {
    opacity: 0;
  }
  .asm-image--shown {
    opacity: 1;
  }
</style>
